import React, {Component} from 'react';
import PropTypes from "prop-types";
import {Link, withRouter} from 'react-router-dom';
import moment from 'moment';
import NotificationSystem from 'react-notification-system';
import {BeatLoader} from 'react-spinners';
import {_addNotification,_addNotificationError} from '../../../../server/util';
import {get,postWithHeaders,patch} from "../../../../server/actions";
import ReactTable from 'react-table';
import '../../../../../src/assets/css/react-table.css';
import _ from 'lodash';
import { date_format } from '../../../../server/constants';
var converter = require('number-to-words');
class EnrollmentSummary extends Component {
    constructor(props){
        super(props);
        this.state={
            loading: false,
            applications:[],
            columns:[],
            startDate : "",
            endDate : "",
            weekCount:0,
            selectedButton: null
        
        }
       
        this.getColumns = this.getColumns.bind(this);
    }
  
    componentDidMount=()=>{
        this._notificationSystem = this.refs.notificationSystem;
        this.getData()
    }
    getData=()=>{
        this.setState({loading:true})
        console.log(this.state.weekCount)
        const schoolID = sessionStorage.getItem("SchoolId")
        const startDate = moment().startOf("isoWeek").add('week',this.state.weekCount).format("YYYY-MM-DD")
        const endDate = moment().startOf('isoWeek').add('week',this.state.weekCount).add('days',4).format("YYYY-MM-DD")
        console.log(startDate,endDate)
        get(`/${schoolID}/enrollments?startDate=${startDate}&endDate=${endDate}&isSummary=true&access_token=`).then((response)=>{
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response.json()
            }).then(data=>{
                console.log(data.response)
                const responsedata = JSON.parse(JSON.stringify(data.response))
                Object.keys(data.response).forEach(item=>{
                    const currentDate = item.split('-')[2]
                    responsedata[item].date = currentDate
                     
                })
                console.log(responsedata)
                const arrayObj = Object.entries(responsedata)
                .sort((a,b) => a[1].date-b[1].date)
            //    .reduce((r, [k, v]) => ({ ...r, [k]: v }), {});

                const finalArray = arrayObj.reduce((r,obj)=>{
                    console.log(obj)
                    Object.keys(obj[1]).forEach(item=>{
                        if(item!=='date'){
                            const isExisted = r.find(x=>x.name===item)
                            if(!isExisted) r.push({name:item})
                            r.map(y=>{
                                if(y.name===item){
                                    y[obj[0]]= obj[1][item]
                                }
                                return y
                            })
                        }
                })
                return r
                },[])
                console.log(finalArray)
                const columns = this.getColumns(finalArray[0])
                const sdate = startDate.split("-")
                const edate = endDate.split("-")
                sdate.shift()
                edate.shift()
                this.setState({columns, applications:finalArray,loading:false,endDate : edate.join("/"),startDate : sdate.join("/")})
             //  console.log( arrayObj)
            }).catch(err=>{
                console.log(err)
            })
    }
    getColumns=(obj)=>{
        let columns = [];
        Object.keys(obj).forEach(item=>{
            columns.push({
                Header: item === "name" ? "" : item,
                style: { textAlign: 'center' },
                accessor: item,
                Cell: row => (
                    item === "name" ?
                    <span ><b>{row.original[item]}</b></span>
                    :
                    <span >{row.original[item]}</span>
                    )
            });
        })
        console.log(columns)
            // columns.push({
            //     Header: '',
            //     style: { textAlign: 'center' },
            // });
            // columns.push({
            //     Header: '07/12',
            //     style: { textAlign: 'center' },
               
            // });
            // columns.push({
            //     Header: '07/13',
            //     style: { textAlign: 'center' },
               
            // });
            // columns.push({
            //     Header: '07/14',
            //     style: { textAlign: 'center' },
                
            // });
            // columns.push({
            //     Header: '07/15',
            //     style: { textAlign: 'center' },
                
            // });
            // columns.push({
            //     Header: '07/16',
            //     style: { textAlign: 'center' },
                
            // });
            
            return columns;
        }
    nextPath(path) {
        this.props.history.push(path);
      }
      handleButtonClick(type){
          if(type==="next"){
            this.setState({weekCount : ++this.state.weekCount,selectedButton:type})
          }else{
            this.setState({weekCount : --this.state.weekCount,selectedButton:type})
          }
          this.getData()
      }
    render(){
        const checkboxProps = {
            getTheadProps: () => {
                return {
                    style: {
                        backgroundColor: "#D2D7D4", fontWeight: 'bold'
                        // color: selected ? 'white' : 'inherit',
                    },
                    className: "bg-success base-reverse"
                };
            },
            getTableProps: () => {
                return {
                    className: "table table-hover"
                }
            },
        };

        return(<div>
            <NotificationSystem ref="notificationSystem"/>
            <div className='sweet-loading' style={{position: 'fixed', top: '50%', left: '48%', zIndex: '1000   '}}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
            <div className="container">          
            <div className="row">
                <div className="col-md-6 col-sm-12 col-xs-12 sectionTitle">
                        <h2>
                        Enrollment Summary
                        </h2>
                        </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <div className="table-responsive">
                        <section className="clearfix">
                            <div className="tab-content">
                                <div className="media">
                                    <div className="panel panel-primary">
                                        <div className="panel-body">
                                                <div className="row">
                                                    <div className="col-md-4 sectionTitle">
                                                        <h2>
                                                            <span>Current Week: <span>{ this.state.startDate ? `${ this.state.startDate.split("-")} - ${this.state.endDate}` : null}</span> </span>
                                                        </h2>
                                                    </div>
                                                    <div className="col-md-4 text-center  btn-group" style={{ marginTop: '14px'}}>
                                                    <button type="button"
                                                            className={`btn btn-xs btn-inactive-color ${this.state.selectedButton === "previous" ? "active" : ''} `}
                                                            id="paymentDue"
                                                            name="paymentDue"
                                                            style={{
                                                                margin: 0,
                                                                marginLeft: 3,
                                                                fontSize: 12
                                                            }}
                                                            onClick={()=>this.handleButtonClick("previous")}
                                                        >Previous
                                                        </button>
                                                    <button type="button"
                                                            className={`btn btn-xs btn-inactive-color ${this.state.selectedButton === "next" ? "active" : ''} `}
                                                            id="paymentDue"
                                                            name="paymentDue"
                                                            style={{
                                                                margin: 0,
                                                                marginLeft: 3,
                                                                fontSize: 12
                                                            }}
                                                            onClick={()=>this.handleButtonClick("next")}
                                                        >Next
                                                        </button>

                                                    </div>
                                                    <div className="col-md-4 text-right"> 
                                                        <button onClick={() => this.nextPath('/schoolAdmin/enrollments') }
                                                            className="btn button-xs btn-success bg-color-1" 
                                                        >
                                                            Enrollments
                                                        </button>
                                                        {/* <button onClick={() => this.nextPath('/schoolAdmin/manageBcAc',"signin") }
                                                            className="btn button-xs btn-success bg-color-2"
                                                        >
                                                            Sign in / Sign out
                                                        </button> */}
                                                        <Link className="btn button-xs btn-success bg-color-2" 
                                                        to={{pathname:'/schoolAdmin/signInAndSignOut',
                                                        state:{
                                                            source:"signInAndOut",
                                                           
                                                        }}}> Sign-In / Sign-Out</Link>
                                                    </div>
                                                </div>
                                        <ReactTable                                                                            
                                            data={this.state.applications}
                                            columns={this.state.columns}
                                            minRows={1} 
                                            className="-striped -highlight"
                                            showPaginationBottom={false}
                                            pageSize ={this.state.applications.length}
                                            
                                        />

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
        </div>)
    }
}
export default withRouter(EnrollmentSummary)



// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/BcAc/ManageBcAc/enrollmentSummary.jsx